const EventIds = [447]
const ConferenceIds = [623]
const NoQuestionsWebinars = [497, 499, 500, 547]

const WebinarTypeVoc = {
  webinar: 'webinar',
  conference: 'conference',
  event: 'event',
}

const WEBINAR_BASE = 'вебинар'
const EVENT_BASE = 'мероприят'
const CONFERENCE_BASE = 'конференц'
const EVENT_BASE_VARIANT_1 = `${EVENT_BASE}ии`
const WEBINAR_VARIANT_1 = `${WEBINAR_BASE}е`
const CONFERENCE_VARIANT_1 = `${CONFERENCE_BASE}ии`
const CONNECT_BASE = 'В случае если вы не можете подключиться к'

const TemplateVariant = {
  title: {
    [WebinarTypeVoc.webinar]: WEBINAR_VARIANT_1,
    [WebinarTypeVoc.event]: `${EVENT_BASE}ии`,
    [WebinarTypeVoc.conference]: CONFERENCE_VARIANT_1,
  },
  during: {
    [WebinarTypeVoc.webinar]: `${WEBINAR_BASE}а`,
    [WebinarTypeVoc.event]: `${EVENT_BASE}ия`,
    [WebinarTypeVoc.conference]: CONFERENCE_VARIANT_1,
  },
  participation: {
    [WebinarTypeVoc.webinar]: EVENT_BASE_VARIANT_1,
    [WebinarTypeVoc.event]: `${EVENT_BASE}ии`,
    [WebinarTypeVoc.conference]: CONFERENCE_VARIANT_1,
  },
  accreditation: {
    [WebinarTypeVoc.webinar]: `Данный ${WEBINAR_BASE} подан`,
    [WebinarTypeVoc.event]: `Данное ${EVENT_BASE}ие подано`,
    [WebinarTypeVoc.conference]: `Данное ${EVENT_BASE}ие подано`,
  },
  program: {
    [WebinarTypeVoc.webinar]: 'программы',
    [WebinarTypeVoc.event]: `${EVENT_BASE}ия`,
    [WebinarTypeVoc.conference]: 'программы',
  },
  link: {
    [WebinarTypeVoc.webinar]: `${EVENT_BASE}ие`,
    [WebinarTypeVoc.event]: 'Консенсус экспертов',
    [WebinarTypeVoc.conference]: 'Конференция',
  },
  eventName: {
    [WebinarTypeVoc.webinar]: `${CONNECT_BASE} ${EVENT_BASE}ию`,
    [WebinarTypeVoc.event]: `${CONNECT_BASE} ${EVENT_BASE}ию`,
    [WebinarTypeVoc.conference]: `В случае возникновения проблем с входом на ${CONFERENCE_BASE}ию`,
  },
}

const WELCOME_MESSAGE = 'Мы приглашаем к участию врачей следующих специальностей'

const EVENTCARD_CHECKBOX_TYPE = 'checkbox'

enum UnavailableReasons {
  unauth = 'unauth',
  unpaid = 'unpaid',
}

enum SubscribeStatus {
  SUBSCRIBED = 'SUBSCRIBED',
  NOT_SUBSCRIBED = 'NOT_SUBSCRIBED',
}

enum WatchStatus {
  NONE = 'none',
  PENDING = 'pending',
  FINISH = 'finish',
}

type AvailableSubscribeStatus = keyof typeof SubscribeStatus

export {
  EventIds,
  NoQuestionsWebinars,
  ConferenceIds,
  TemplateVariant,
  WebinarTypeVoc,
  WELCOME_MESSAGE,
  EVENTCARD_CHECKBOX_TYPE,
  UnavailableReasons,
  SubscribeStatus,
  WatchStatus,
}
export type { AvailableSubscribeStatus }
